import { render, staticRenderFns } from "./TreatmentSessionMarkingElements.vue?vue&type=template&id=1c40565f"
import script from "./TreatmentSessionMarkingElements.vue?vue&type=script&lang=js"
export * from "./TreatmentSessionMarkingElements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports